import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AbsentModel } from 'data/absent/absent.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AbsentModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AbsentModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const absentByGradeSlice = createSlice({
  name: 'absentByGrade',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default absentByGradeSlice;
